import styled from 'styled-components';
import { themeSize } from '../../../../theme/getters';
import { media } from '../../../../theme/media';
import { animatedPlaceholder } from '../../../../theme/mixins';

export const List = styled.ul`
  width: 100%;
  display: grid;
  padding: 32px 0 0;
  row-gap: 56px;
  grid-template-columns: 1fr;

  ${media.mobileBig`
    grid-template-columns: repeat(2, 1fr);
  `};

  ${media.tablet`
    grid-template-columns: repeat(3, 1fr);
    padding: 56px 0 0;
    grid-row-gap: 80px;
  `};
  column-gap: ${themeSize('contentPadding')}px;
  flex-direction: row;
  margin: 0;
  justify-content: center;
`;

export const Placeholder = styled.div`
  ${animatedPlaceholder};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  padding-top: ${({ ratio }) => ratio * 100}%;

  ${media.desktop`
    min-width: 300px;
  `};
`;
